(function () {
  var LINE_LIMIT = 5;

  function setup(root) {
    var content = root.querySelector('[data-collection-description-content]');
    var toggle = root.querySelector('[data-collection-description-toggle]');
    if (!content || !toggle) return;

    var sample = content.querySelector('p, li, div, span') || content;
    var lineHeight = parseFloat(window.getComputedStyle(sample).lineHeight);
    if (isNaN(lineHeight)) {
      lineHeight = parseFloat(window.getComputedStyle(sample).fontSize) * 1.6;
    }

    var collapsedHeight = Math.ceil(lineHeight * LINE_LIMIT);
    content.style.setProperty('--collection-description-collapsed-height', collapsedHeight + 'px');

    content.classList.add('is-collapsed');
    content.classList.remove('is-expanded');
    content.style.maxHeight = collapsedHeight + 'px';

    if (content.scrollHeight <= collapsedHeight + 2) {
      content.classList.remove('is-collapsed');
      content.style.maxHeight = 'none';
      toggle.classList.remove('is-visible');
      return;
    }

    toggle.classList.add('is-visible');
  }

  function setupAll(scope) {
    var descriptions = (scope || document).querySelectorAll('[data-collection-description]');
    for (var i = 0; i < descriptions.length; i++) {
      setup(descriptions[i]);
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-collection-description-toggle]');
    if (!toggle) return;

    var root = toggle.closest('[data-collection-description]');
    var content = root && root.querySelector('[data-collection-description-content]');
    if (!content) return;

    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    toggle.textContent = isExpanded ? 'View More' : 'View Less';
    content.classList.toggle('is-collapsed', isExpanded);
    content.classList.toggle('is-expanded', !isExpanded);
    content.style.maxHeight = isExpanded
      ? content.style.getPropertyValue('--collection-description-collapsed-height')
      : content.scrollHeight + 'px';
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll(document);
    });
  } else {
    setupAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
